import Vue from 'vue'
import Vuex from 'vuex'
import {getCookie} from '@/utils/cookie.js'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		token: '',
        userID: '',
        userName: '',
        userSig: '',
        roomId: '',
        roleType:'',
	},
	mutations: {
		setToken(state, token) {
            state.token = token || getCookie('roomToken')
            console.log('token', getCookie('roomToken'))
        },
        setUserInfo(state, userInfo) {
            let info = JSON.parse(getCookie('userInfo'))
            state.userID = userInfo.id || info.id
            state.userName = userInfo.name || info.name
        },
        setUserSig(state, userSig) {
            state.userSig = userSig || getCookie('userSig')
        },
        setRoomId(state, roomId) {
            state.roomId = roomId || getCookie('roomId')
        },
        roleTypeMutations(state,type){
            state.roleType = type
        }
	},
	actions: {
		
	}})
export default store